import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Skeleton } from "@/components/ui/skeleton";
import { Switch } from "@/components/ui/switch";
import {
  usePlatformSettings,
  useUpdatePlatformSettings,
  type UpdatePlatformSettingsInput,
} from "@/hooks/usePlatformSettings";

export const PricingSettingsSection = () => {
  const { data, isLoading } = usePlatformSettings();
  const update = useUpdatePlatformSettings();

  const [form, setForm] = useState({
    showPrices: true,
  });

  useEffect(() => {
    if (!data) return;
    setForm({
      showPrices: data.showPrices !== false,
    });
  }, [data]);

  const onSave = () => {
    const payload: UpdatePlatformSettingsInput = {
      showPrices: form.showPrices,
    };
    update.mutate(payload, {
      onSuccess: () =>
        toast.success(
          form.showPrices
            ? "Price details are now visible to everyone."
            : "Price details are now hidden from customer and provider apps.",
        ),
      onError: (e) => toast.error(e.message),
    });
  };

  if (isLoading) return <Skeleton className="h-24 w-full" />;

  return (
    <section className="rounded-card border border-border p-5 bg-card space-y-4">
      <header className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-lg font-semibold">Pricing & packages display</h2>
          <p className="text-sm text-muted-foreground">
            Toggle the visibility of pricing and package details across both the
            customer and provider mobile applications.
          </p>
        </div>
        <div className="flex items-center gap-2 pt-1">
          <Switch
            checked={form.showPrices}
            onCheckedChange={(checked) => setForm({ showPrices: checked })}
          />
          <Label className="text-sm">
            {form.showPrices ? "SHOW PRICES" : "HIDE PRICES"}
          </Label>
        </div>
      </header>

      <div className="flex justify-end">
        <Button onClick={onSave} disabled={update.isPending}>
          {update.isPending ? "Saving…" : "Save pricing settings"}
        </Button>
      </div>
    </section>
  );
};
